var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tabs',{staticClass:"shop-gallery__big-img",attrs:{"slider-color":'#E4183E',"show-arrows":""}},_vm._l((_vm.images),function(item,id){return _c('v-tab',{key:id,staticClass:"shop-gallery",style:({background: 'url(' + item + ') 50% 50% / 90px 90px no-repeat '}),on:{"click":function($event){return _vm.changeImage(item)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }